import { ChangeDetectionStrategy, Component, Input, ChangeDetectorRef, OnInit, OnDestroy } from "@angular/core";
import { Observable } from 'rxjs/Observable';
import { Asset } from "app/models/asset";
import { Location } from "app/models/location";

import swal from "bootstrap-sweetalert";
import * as _ from 'lodash';

import { Subscription } from "rxjs/Subscription";
import { AssetService } from "app/services/asset.service";
import { ActivatedRoute, Router } from "@angular/router";
import { ServiceObject, ServiceObjectBase } from "app/models/serviceObject";
import { LocationService } from "app/services/location.service";
import { BsModalRef } from "ngx-bootstrap";

@Component({
  selector: 'modal-content',
  templateUrl: './serviceObject-search.component.html',
  styleUrls: ['./serviceObject-search.component.scss']
})
export class ServiceObjectSearchComponent implements OnDestroy {

  constructor(
    private assetService: AssetService,
    private locationService: LocationService,
    private router: Router,
    public searchModal: BsModalRef
  ) { }

  private errorState: ServiceObjectSearchComponent.ErrorState = ServiceObjectSearchComponent.ErrorState.None;
  private assets: Asset[];
  private locations: Location[];
  private searchString: string;
  private loading: boolean = false;

  ngOnDestroy(): void {
    this.clearSubscription();
    swal.close();
  }

  private navigate(url: string) {
    this.close();
    this.router.navigate([url]);
  }

  loadData() {
    if (this.searchString == null || this.searchString.trim() == '')
      return;

    this.errorState = ServiceObjectSearchComponent.ErrorState.None;
    this.clearSubscription();
    this.loading = true;
    this.assets = null;
    this.locations = null;


    this.assetPathLoadSubscription = Observable.forkJoin(this.locationService.getLocationsByName(this.searchString), this.assetService.getAssetsByName(this.searchString))
      .flatMap(serviceObjects => { 
        const [locations, assets] = serviceObjects;
        var downloadAddressesObservable = Observable.merge(...assets.map(asset =>
          this.assetService.getAssetPath(asset.id)
            // для каждого объекта обслуживания, асинхронно получаем его путь (адрес)
            .do(assetPath => {
              if (assetPath.length > 0) {
                var location = assetPath[0] as Location;
                asset.address = (location.address != null) ? location.address : "";
              } else {
                console.error("Server error! Could not get asset address");
              }
            })
            .ignoreElements()
            // производим приведения типов, т.к. нам нужно получить конкретный тип
            .map(_ => <[Location[], Asset[]]>null))
        );
        // соединяем два Observable (объекты обслуживания и загрузку адресов для активов)
        return Observable.concat(Observable.of(serviceObjects), downloadAddressesObservable);
      }).subscribe(result => {
        const [locations, assets] = result;
        this.locations = locations;
        this.assets = assets;

      }, error => {
        this.errorState = ServiceObjectSearchComponent.ErrorState.UnknownError;
        swal({
          title: 'Ошибка',
          text: 'Не удалось получить объекты обслуживания. Попробуйте снова',
          type: 'error',
          confirmButtonText: 'Попробовать еще раз'
        }, () => {
          this.loadData();
        });
      },
      () => this.loading = false);

  }

  private close() {
    this.clearSubscription();
    this.searchModal.hide();
  }

  private clearSubscription() {
    if (this.assetPathLoadSubscription)
      this.assetPathLoadSubscription.unsubscribe();

    this.assetPathLoadSubscription = null;
  }

  private assetPathLoadSubscription: Subscription;
  private ErrorStateEnum = ServiceObjectSearchComponent.ErrorState;
}

export namespace ServiceObjectSearchComponent {

  export enum ErrorState {
    /**
     * Нет ошибок
     */
    None,
    /**
     * Другая ошибка при получении данных с сервера
     */
    UnknownError
  }
}



// WEBPACK FOOTER //
// /app/SPA/src/app/client/serviceObject/search/serviceObject-search.component.ts